var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"xlsx"}},[_c('el-button',{staticStyle:{"float":"right"},attrs:{"type":"success","size":"small"},on:{"click":_vm.exportex}},[_vm._v("导出")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }